import {React, useState, confirmAlert, FC, useMemo} from 'external/react'
import {styled} from 'external/material'
import {saveTemplate, saveRDTemplate} from 'context/post'

import {isEmpty} from 'helpers/utils'

type SaveTemplateDialogProps = {
  rd?: boolean
  onClose: () => void
  context: any
}

const StyledSaveTemplateDialog = styled('div')(saveTemplateDialogStyles as any)

const SaveTemplateDialog:FC<SaveTemplateDialogProps> = (props) => {

  const {onClose, rd=undefined, context} = props
  const {translate, updateState, newPlan} = context
  const [name, setName] = useState(newPlan.title || "") 
  const canSave = useMemo(() => !isEmpty(name), [name])
  return (
    <StyledSaveTemplateDialog className="save-template-dialog">
      <div className="title">
        {translate('save_template_label')}
      </div>
      <div className="input">
        <input value={name} type="text" onChange={e => setName(e.target.value)} />
      </div>
      <div className="buttons">
        <button className="save button" disabled={!canSave} onClick={async () => {
            const save = rd ? saveRDTemplate : saveTemplate
            await save(name, newPlan)
            await updateState({templateUpdates: {$apply: (i:number) => i + 1}})
            onClose()
          }}
        >
          {translate('save_label')}
        </button>
        <div className="cancel button" onClick={onClose}>
          {translate('cancel_label')}
        </div>
      </div>
    </StyledSaveTemplateDialog>
  )
}

export function saveTemplateDialog (props: any) {
  return confirmAlert({
    customUI: ({onClose}) => (<SaveTemplateDialog {...{...props, onClose}}/>)
  })
}


function saveTemplateDialogStyles() {
  return {
     border: "solid 1px #bcc0c9",
     color: "#515a71",
     borderRadius: "6px",
     padding: "20px 50px",
     backgroundColor: "#edf1f5",
     display: "flex",
     flexDirection: "column",
     justifyContent: "center",
      "& > div": {
        display: "flex"
      },
      "& .title": {
        fontWeight: "bold",
        fontSize: "13pt"
      },
      "& .input": {
        marginTop: "10px",
        "& input": {
          flexGrow: 1
        }
      },
      "& .buttons": {
        marginTop: "25px",
        justifyContent: "center",
        "& .button": {
          cursor: "pointer",
          fontSize: "12pt",
          width: "70px",
          textAlign: "center",
          borderRadius: "5px",
          padding: "4px 0",
          "&:hover": {
            transform: "scale(1.04)"
          },
          "&.save:disabled,&.save[disabled]": {
            cursor: "default",
            opacity: "0.5",
            border: "1px solid #999999",
            backgroundColor: "#cccccc",
            color: "#666666",
            "&:hover": {
              transform: "none"
            }
          },
          "&.save": {
            marginRight: "15px",
            border: "solid 1px #2ca5ec",
            backgroundColor: "#2ca5ec",
            color: "#fff"
          },
          "&.cancel": {
            border: "solid 1px #c2c5c6",
            color: "#ef4747"
          }
        }
      }
  }
}